// extracted by mini-css-extract-plugin
export default {"card":"NotificationCard_card__7WFVn","item":"NotificationCard_item__equoq","title":"NotificationCard_title__Shsg-"};